import { create } from "../../../common/utils/zustand_state_manager";
import { ConfigureLoginUseCase } from "../../../features/auth/domain/useCases/read/configure_login_use_case";
import { GetEnterprisesUseCase } from "../../../features/auth/domain/useCases/read/get_enterprises_use_case";
import { LoginAvailableUseCase } from "../../../features/auth/domain/useCases/read/login_available_use_case";
import { LoginUseCase } from "../../../features/auth/domain/useCases/read/login_use_case";
import { IConfigureLoginUseCase } from "../../../features/auth/presentation/useCases/read/configure_login_use_case";
import { IGetEnterprisesUseCase } from "../../../features/auth/presentation/useCases/read/get_enterprises_use_case";
import { ILoginAvailableUseCase } from "../../../features/auth/presentation/useCases/read/login_available_use_case";
import { ILoginUseCase } from "../../../features/auth/presentation/useCases/read/login_use_case";
import { useAuthRepositories } from "./use_repositories";
import { IEsqueceuSuaSenhaUseCase } from '../../../features/auth/presentation/useCases/update/esqueceu_sua_senha_use_case';
import { EsqueceuSuaSenhaUseCase } from '../../../features/auth/domain/useCases/update/esqueceu_sua_senha_use_case';
import { ITrocarSenhaUseCase } from '../../../features/auth/presentation/useCases/update/trocar_senha_use_case';
import { TrocarSenhaUseCase } from '../../../features/auth/domain/useCases/update/trocar_senha_use_case'; // {{ LAST DECL IMPORT }}

/**
 * useAuthUseCases
 */

export type AuthUseState = {
  loginUseCase: ILoginUseCase,
  getEnterprisesUseCase: IGetEnterprisesUseCase,
  configureLoginUseCase: IConfigureLoginUseCase,
  loginAvailableUseCase: ILoginAvailableUseCase,
  esqueceuSuaSenhaUseCase: IEsqueceuSuaSenhaUseCase,
  trocarSenhaUseCase: ITrocarSenhaUseCase, // {{ LAST DECL INTERFACE }}
};

export const useAuthUseCases = create<AuthUseState>(() => {
  const { authRepository: repository } = useAuthRepositories.getState();
  return ({
    loginUseCase: new LoginUseCase(repository),
    getEnterprisesUseCase: new GetEnterprisesUseCase(repository),
    configureLoginUseCase: new ConfigureLoginUseCase(repository),
    loginAvailableUseCase: new LoginAvailableUseCase(repository),
    esqueceuSuaSenhaUseCase: new EsqueceuSuaSenhaUseCase(repository),
    trocarSenhaUseCase: new TrocarSenhaUseCase(repository), // {{ LAST DECL IMPLEMENTATION }}
  });
});